<template>
  <a-spin :spinning="!this.chartData">
    <span >Select year:<select id="migrateBarChartYear"></select></span>
    <br />
    Sort
    <a-checkbox id="sort" />
    
    <br />
    <svg style="background-color:white" id="migrateBarChart" ></svg>
    <p style="text-align: center">Most aging countries have large immigrant and the immigrant that able to work has increasing ratio. <br>However based on diffrent national conditions and policies, Australia and Asia countries show slitly different result.</p>
  </a-spin>
</template>

<script>
import * as d3 from "d3";


export default {
  name: "MigrateBarChart",
  data: function () {
    return {
      chartData: null,
    };
  },
  methods: {
    makeMigrateBarChart(csv) {
      // console.log('csv is ',csv)
      var keys = csv.columns.slice(2);

      var year = [...new Set(csv.map((d) => d.Year))];
      var country = [...new Set(csv.map((d) => d.Country))];

      // add year filter
       d3
        .select("#migrateBarChartYear")
        .selectAll("option")
        .data(year)
        .enter()
        .append("option")
        .text((d) => d);

      var margin = { top: 40, left: 100, bottom: 0, right: 130 },
        width = 1100 - margin.left - margin.right,
        height = 450 - margin.top - margin.bottom;

      var svg = d3.select("#migrateBarChart").attr("viewBox", `0 0 1100 450`)


      // add title
          svg.append("text")
    .style("text-anchor", "middle")
        .style("font-size", "18")
        // .style("opacity","1")
        .attr("x",width/2 + 100)
        .attr("y","13")
        .style("font-weight","700")
        .text("International migrant stock percentage by age")


        // add x legend
          svg.append("text")
    .style("text-anchor", "start")
        .style("font-size", "10")
        .style("opacity","0.7")
        .attr("x",width + margin.left +10)
        .attr("y",margin.top)
        // .style("font-weight","700")
        .text("% of total population")



      var y = d3
        .scaleBand()
        .range([margin.top, height - margin.bottom])
        .padding(0.1)
        .paddingOuter(0.2)
        .paddingInner(0.2);

      var x = d3.scaleLinear().range([margin.left, width + margin.left]);

        // y axis
      svg
        .append("g")
        .attr("transform", `translate(${margin.left + x(0.2184)},0)`)
        .attr("class", "y-axis");
    
        // x axis
      svg
        .append("g")
        .attr("transform", `translate(0,${margin.top})`)
        .attr("class", "x-axis");

      var z = d3
        .scaleOrdinal()
        .range(["white", "#b2beb5", "#8db600", "#21abcd", "#e9d66b"])
        .domain(keys);

      update(d3.select("#migrateBarChartYear").property("value"), 0);

      function update(input, speed) {
        var data = csv.filter((f) => f.Year == input);
        // console.log('data is :', data)

        // count the total immigrant ratio
        data.forEach(function (d) {
          d.total = d3.sum(keys, (k) => +d[k]);
          d.temp = +d.temp;
          d.emmigrant = +d.emmigrant;
          return d;
        });
        // console.log(data)

        // set x-axis
        x.domain([-15, 30]).nice();

        svg
          .selectAll(".x-axis")
          .transition()
          .duration(speed)
          .call(d3.axisTop(x).ticks(null, "s"));

        // update the sort checkbox

        // console.log('checkbox is ',d3.select('#sort').property("checked"))
        data.sort(
          d3.select("#sort").property("checked")
            ? (a, b) => b.total - a.total
            : (a, b) => country.indexOf(a.Country) - country.indexOf(b.Country)
        );

        // set y-axis
        y.domain(data.map((d) => d.Country));

        svg
          .selectAll(".y-axis")
          .transition()
          .duration(speed)
          .call(d3.axisLeft(y).tickSizeOuter(0))
          .call((svg) =>
            svg
              .selectAll(".tick text")
              .attr("text-anchor", "start")
              .attr("font-size", "15px")
              .attr("font-family","cursive")
              .attr("font-weight","550")
              .attr("x", x(-38))
          );

        var group = svg
          .selectAll("g.layer")
          .data(d3.stack().keys(keys)(data), (d) => d.key);

        group.exit().remove();

        group
          .enter()
          .insert("g", ".y-axis")
          .append("g")
          .classed("layer", true)
          .attr("fill", (d) => z(d.key));

        var bars = svg
          .selectAll("g.layer")
          .selectAll("rect")
          .data(
            (d) => d,
            (e) => {
              // console.log('e is ',e)
              return e.data.Country;
            }
          );
        // console.log('bars is',bars)

        bars.exit().remove();

        bars
          .enter()
          .append("rect")
          .attr("height", y.bandwidth())
          .merge(bars)
          .transition()
          .duration(speed)
          .attr("y", (d) => {
            // console.log('d is:', d)
            return y(d.data.Country);
          })
          .attr("x", (d) => x(d[0]))
          .attr("width", (d) => {
            if (d[1] < 0) {
              return x(0);
            } else {
              return x(d[1]) - x(d[0]);
            }
          });

        var text = svg.selectAll(".text").data(data, (d) => d.Country);

        text.exit().remove();

        text
          .enter()
          .append("text")
          .attr("class", "text")
          .attr("text-anchor", "end")
          .attr("font-family","cursive")
          .attr("font-size", "12px")
          .merge(text)
          .transition()
          .duration(speed)
          .attr("y", (d) => y(d.Country) + y.bandwidth() / 2 +5)
          .attr("x", (d) => x(d.emmigrant) - 5)
          .text((d) => `${d.temp.toPrecision(2)}%`);

        var text2 = svg.selectAll(".text2").data(data, (d) => d.Country);

        // text2.exit().remove()

        text2
          .enter()
          .append("text")
          .attr("class", "text2")
          .attr("text-anchor", "start")
          .attr("font-family","cursive")
          .attr("font-size", "12px")
          .merge(text2)
          .transition()
          .duration(speed)
          .attr("y", (d) => y(d.Country) + y.bandwidth() / 2 +5)
          .attr("x", (d) => x(d.total) + 5)
          .text((d) => `${d.total.toPrecision(2)}%`);

        svg.append("line").attr();
      }

      // ser filter
      var select = d3.select("#migrateBarChartYear").on("change", function () {
        update(this.value, 750);
      });

    // checkbox
       d3.select("#sort").on("click", function () {
        update(select.property("value"), 750);
      });
      // add legend

      var size = 13;
      svg
        .selectAll("mydots")
        .data(keys)
        .enter()
        .append("rect")
        .attr("x", margin.left + width + 30)
        .attr("y", function (d, i) {
          return 50 + i * (size + 5);
        }) // 100 is where the first dot appears. 25 is the distance between dots
        .attr("width", size)
        .attr("height", size)
        .style("fill", function (d) {
          return z(d);
        });

      // Add one dot in the legend for each name.
      svg
        .selectAll("mylabels")
        .data(keys)
        .enter()
        .append("text")
        .attr("font-family","cursive")
        .attr("x", margin.left + width + 25 + size * 1.5)
        .attr("y", function (d, i) {
          return 50 + i * (size + 5) + size / 2;
        }) // 100 is where the first dot appears. 25 is the distance between dots
        .style("fill", function (d) {
          return z(d);
        })
        .text(function (d) {
          if (d == "temp") {
            return "emigrant total";
          } else {
            return `immigrant ${d}`;
          }
        })
        .attr("text-anchor", "left")
        .style("alignment-baseline", "middle")
        .style("font-size", "11");
    },
  },
  mounted: function () {
    const API = this.$store.state.API;
    if (!this.$store.state.migrateBarData) {
      d3
        .csv(`${API}migrate_total.csv`)
        .then((result) => {
          // console.log('result is ',result)
          this.chartData = result;
          this.$store.commit("migrateBarData", result);
          this.makeMigrateBarChart(this.chartData);
        })
        .catch((e) => {
          console.error("Error: ", e);
        });
    } else {
      this.chartData = this.$store.state.migrateBarData;
      // console.log("vuex chartData is ", this.chartData);
      this.makeMigrateBarChart(this.chartData);
    }
  },
};
</script>

<style scoped>
</style>